<template>
  <div class="wrapper">
    <b-form
      class="buy"
      @submit.prevent="buy">
      <!-- Блок для фиксированного количества и цены-->
      <b-form-group
        v-if="showCount"
        class="input-group input-count">
        <span> Количество </span>
        <b-form-input
          v-model="count"
          :max="maxCount >= 0 ? maxCount : ''"
          class="input"
          type="number"
          @keyup="countHandler()"/>
      </b-form-group>

      <!-- Блок для расчета цены по атрибутам-->
      <template v-for="(attribute, index) in attributesCopy">
        <div
          v-if="attribute.filled_by_buyer == 1"
          :key="index"
          :class="formValid ? 'check-valid' : 'check-not-valid'">
          <typeList :attr="attribute"/>
        </div>
      </template>
      <div
        v-if="customAttributesCopy && customAttributesCopy.length != 0"
        class="custom-attributes">
        <customAttribute
          v-for="(attribute, index) in customAttributesCopy"
          :key="'custom-' + index"
          :attribute="attribute"/>
      </div>
      <div
        v-if="calculateError != null"
        class="calculate-error">
        {{ calculateError }}
      </div>
      <div v-if="calculateTotalPrice == null && price == null">
        <span class="required">*</span> Заполните обязательные поля для расчета
        цены
      </div>

      <div class="total">
        <!-- Показываем цену офера-->
        <div
          itemprop="priceCurrency"
          content="USD"
          class="buy-total">
          <strong
            itemprop="price"
            :content="calculateTotalPrice ? calculateTotalPrice.toFixed(2) : 0">
            Итого:
          </strong>
          {{ calculateTotalPrice }} руб.
        </div>
        <!-- Показываем время офера-->
        <div
          v-if="calculateTotalTime != null && !isInstantDelivery"
          class="payment">
          Выполнение в течение
          <template v-if="calculateTotalTime < 60">
            {{ Math.round(calculateTotalTime * 10) / 10 }} минут
          </template>
          <template v-else>
            {{ Math.round((calculateTotalTime / 60) * 10) / 10 }} часов
          </template>
        </div>
        <div
          v-if="isInstantDelivery"
          class="payment">
          <span class="time-instantly">Мгновенно</span>
        </div>
        <button
          v-if="minimumSum == null"
          :disabled="
            (price === null && calculateTotalPrice === null) ||
              calculateProgress
          "
          class="btn btn-success buy-submit">
          <template v-if="calculateProgress">
            Загрузка
          </template>
          <template v-else>
            Купить
          </template>
        </button>
        <button
          v-else
          :disabled="
            (price === null && calculateTotalPrice === null) ||
              calculateProgress ||
              (calculateTotalPrice != null && calculateTotalPrice < minimumSum)
          "
          class="btn btn-success buy-submit">
          <template v-if="calculateProgress">
            Загрузка
          </template>
          <template v-else>
            Купить
          </template>
        </button>
      </div>

      <div
        :class="
          (price != null && price < minimumSum) ||
            (calculateTotalPrice != null && calculateTotalPrice < minimumSum)
            ? 'minimum-sum error'
            : 'minimum-sum'
        ">
        Минимальный заказ: {{ minimumSum == null ? 0 : minimumSum }} руб.
      </div>
    </b-form>
    <modalPayment
      v-if="user"
      :show="modalPaymentShow"
      :product-title="title"
      :count="count"
      :offer-price="calculateTotalPrice"
      :order-id="orderId"
      :modal-close="modalPaymentClose"
      @payment-success="paymentSuccess"/>
  </div>
</template>


<script>
import typeList from "~/components/offer/calculate/typeList.vue";
import customAttribute from "~/components/offer/calculate/customAttribute.vue";
import { makeFormulas } from "~/services/offer-formula-calculate";
import { makeFormulasCustom } from "~/services/offer-formula-calculate-custom";
import { errorResponse } from "~/services/errors-template";
import modalPayment from "~/components/modals/payment.vue";
import { mapState } from "vuex";
import axios from "axios";

let timeout;

export default {
  components: {
    typeList,
    modalPayment,
    customAttribute,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
    title: {
      type: String,
      default: "",
    },
    attributes: {
      type: Array,
      default: () => [],
    },
    customAttributes: {
      type: Array,
      default: () => [],
    },
    showCount: {
      type: Boolean,
      default: false,
    },
    showPrice: {
      type: Boolean,
      default: false,
    },
    showTime: {
      type: Boolean,
      default: false,
    },
    maxCount: {
      type: Number,
      default: 1,
    },
    price: {
      type: Number,
      default: null,
    },
    totalPrice: {
      type: Number,
      default: null,
    },
    totalTime: {
      type: Number,
      default: null,
    },
    minimumSum: {
      type: Number,
      default: null,
    },
    isInstantDelivery: {
      type: Boolean,
      default: false,
    },
    priceMultiplier: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      modalPaymentShow: false,
      count: this.priceMultiplier,
      orderId: null,
      attributesCopy: this.attributes.slice(),
      customAttributesCopy: this.customAttributes.slice(),
      postData: {},
      calculateTotalPrice: this.totalPrice,
      calculateTotalTime: this.totalTime,
      formValid: true,
      calculateError: null,
    };
  },
  computed: mapState({
    user: (state) => state.auth.user,
    calculateTrigger: (state) => state.offer.calculateTrigger,
    calculateProgress: (state) => state.offer.calculateStatus,
  }),
  watch: {
    calculateTrigger: function () {
      this.calculate();
    },
  },
  mounted() {
    this.calculate();
    this.$root.$on("bv::modal::hide", (event, modalId) => {
      if (modalId == "modalPayment") {
        this.modalPaymentClose();
      }
    });
  },
  methods: {
    paymentSuccess(orderId) {
      this.$router.push({
        path: "/profile/purchases/" + orderId
      });
    },
    countHandler() {
      clearTimeout(timeout);
      if (this.count == "") {
        this.count = 1;
      }
      if (this.maxCount > 0 && this.count > this.maxCount) {
        this.count = this.maxCount;
      }
      timeout = setTimeout(() => {
        this.calculate();
        this.$yandexMetrika.reachGoal(
          "buyer_interact-with-offer-calculate-form"
        );
      }, 300);
    },
    validate: function () {
      for (let i = 0; i < this.attributesCopy.length; i++) {
        if (this.attributesCopy[i].required_by_buyer != 1) continue;
        if (this.attributesCopy[i].value === "") {
          this.formValid = false;
          return false;
        }
      }
      return true;
    },
    calculate: function () {
      this.$store.dispatch("offer/CHANGE_CALCULATE_STATUS", true);
      this.postData.offer_id = this.id;
      this.postData.count = this.count;
      this.postData.attributesValues = makeFormulas(this.attributesCopy);
      this.postData.customAttributesValues = makeFormulasCustom(
        this.customAttributesCopy
      );

      console.log(this.postData.attributesValues);
      for (let i = 0; i < this.attributesCopy.length; i++) {
        if (
          this.attributesCopy[i].required_by_buyer == 1 &&
          (this.attributesCopy[i].affects_price == 1 ||
            this.attributesCopy[i].affects_time == 1) &&
          !this.postData.attributesValues[this.attributesCopy[i].id]
        ) {
          this.$store.dispatch("offer/CHANGE_CALCULATE_STATUS", false);
          this.formValid = false;
          this.postData = {};
          return;
        }
      }
      console.log(this.formValid);
      this.formValid = true;
      return axios
        .post("/offers/price-and-time", this.postData)
        .then((response) => {
          if (response.data.success) {
            if (!this.showPrice && !this.showTime) {
              let errors = response.data.data.price.errors;
              if (errors && errors.length != 0) {
                this.checkCalculateErrors(errors);
              } else {
                this.calculateError = null;
                this.calculateTotalPrice =
                  Math.round(response.data.data.price.value * 100) / 100;
                this.calculateTotalTime = response.data.data.time.value;
              }
            } else {
              if (!this.showPrice) {
                let errors = response.data.data.price.errors;
                if (errors && errors.length != 0) {
                  this.checkCalculateErrors(errors);
                } else {
                  this.calculateError = null;
                  this.calculateTotalPrice =
                    Math.round(response.data.data.price.value * 100) / 100;
                }
              } else {
                this.calculateTotalPrice =
                  Math.round(response.data.data.price.value * 100) / 100;
              }
              if (!this.showTime) {
                let errors = response.data.data.price.errors;
                if (errors && errors.length != 0) {
                  this.checkCalculateErrors(errors);
                } else {
                  this.calculateError = null;
                  this.calculateTotalTime = response.data.data.time.value;
                }
              }
            }
            this.$store.dispatch("offer/CHANGE_CALCULATE_STATUS", false);
          } else {
            this.$store.dispatch("offer/CHANGE_CALCULATE_STATUS", false);
            this.$noty.error("Ошибка сервера. " + response.data);
          }
        })
        .catch((exception) => {
          this.$store.dispatch("offer/CHANGE_CALCULATE_STATUS", false);
          this.$noty.error(
            "Ошибка сервера. " + exception.response.data.data.message
          );
          return exception.response;
        });
    },
    checkCalculateErrors: function (errors) {
      this.formValid = false;
      this.calculateError =
        "Продавец не выполняет заказы с введенными параметрами, пожалуйста измените данные для покупки";
      for (let i = 0; i < this.attributesCopy.length; i++) {
        if (errors.indexOf(this.attributesCopy[i].id) != -1) {
          this.attributesCopy[i].valid = false;
        }
      }
    },
    modalPaymentClose: function () {
      this.modalPaymentShow = false;
    },
    buy() {
      let order = {};
      if (!this.user) {
        this.$yandexMetrika.reachGoal("buyer_auth-interrupt-for-make-order");
        this.$root.$emit("bv::show::modal", "modalLoginSocial");
        return;
      }
      if (this.calculateProgress) {
        return;
      }
      if (!this.validate()) return;
      order.offer_id = this.id;
      order.count = parseInt(this.count);
      order.attributesValues = {};
      for (let i = 0; i < this.attributesCopy.length; i++) {
        let key = this.attributesCopy[i].id;
        order.attributesValues[key] = this.attributesCopy[i].value;
      }
      order.customAttributesValues = this.postData.customAttributesValues;
      this.formValid = true;
      axios
        .post("/orders", order)
        .then((response) => {
          if (response.data.success) {
            this.orderId = response.data.data.id;
            this.calculateTotalPrice = response.data.data.price;
            this.modalPaymentShow = true;
            this.$yandexMetrika.reachGoal("buyer_payment-modal-shown");
            this.$store.commit("order/setOrder", response.data.data);
          } else {
            this.$noty.error(errorResponse(response.data.data));
          }
        })
        .catch((exception) => {
          console.log(exception);
          if (exception.response.status == 401) {
            this.$root.$emit("bv::show::modal", "modalLoginSocial");
          } else if (!this.user.is_active && exception.response.status == 403) {
            this.$root.$emit("bv::show::modal", "modalRegistrationCode");
          } else if (this.user.is_active && exception.response.status == 403) {
            this.$noty.error(errorResponse(exception.response.data.data));
          } else {
            console.log(exception.response.data.data);
            this.$noty.error(errorResponse(exception.response.data.data));
            return exception.response;
          }
        });
    },
  },
};
</script>


<style lang="scss" scoped>
.wrapper {
  position: relative;
  height: 100%;
  padding-bottom: 55px;
}
.attribute {
  margin-bottom: 20px;
  font-size: 14px;
}

.buy {
  padding: 26px 34px;
  font-size: 14px;
}
.buy-group {
  margin-bottom: 14px;
  span {
    display: block;
    margin-bottom: 5px;
  }
}
.buy-input {
  height: 40px;
}

.total {
  margin: 20px -18px 0;
  padding: 16px;
  background: #f7f9fc;
  border-radius: 4px;
}
.buy-total {
  margin-top: 21px;
  font-size: 20px;
  font-weight: 500;
  strong {
    font-weight: 500;
  }
  &:first-child {
    margin-top: 0;
  }
  + .buy-submit {
    margin-top: 10px;
  }
}
.buy-submit {
  width: 100%;
  height: 40px;
  font-size: 14px;
}
.buy-course {
  margin-top: 13px;
  font-size: 14px;
  color: #a8aaaf;
  text-align: center;
}
.input-count {
  span {
    display: block;
    margin-bottom: 5px;
  }
  input {
    width: 100%;
  }
}

.payment {
  margin-bottom: 10px;
  margin-top: 3px;
  font-size: 12px;
  font-weight: 500;
  color: #a8aaaf;
}

.time-instantly {
  color: $body-color;
  &:before {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    height: 20px;
    content: "";
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMCAwVjExSDNWMjBMMTAgOEg2TDEwIDBIMFoiIGZpbGw9IiNGRkIwMDAiLz4KPC9zdmc+Cg==");
  }
}
.required {
  color: $red;
}
.custom-attributes {
  margin-bottom: 20px;
}

.minimum-sum {
  margin-top: 8px;
  font-size: 12px;
  font-weight: 500;
  color: #a8aaaf;
  text-align: center;
  &.error {
    color: $red;
  }
}
.calculate-error {
  margin-bottom: 15px;
  color: $red;
}
</style>
